import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  from,
  InMemoryCache,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { createUploadLink } from "apollo-upload-client";

import {
  AWS_REGIONS,
  GRAPHQL_PATH,
  REGION_CONFIGS,
} from "shell/platform/constants/constants";

import { loadingLocksManager } from "../utils/loadingLocksManager";
import { getCurrentRegion } from "../utils/regionalApolloClientUtils";
import { getSessionHeaders } from "./oidcClient";

const loadingLink = new ApolloLink((operation, forward) => {
  const useLoadingLocks = operation.getContext().withLoadingLocks;
  const lockId = operation.getContext().loadingLockId;

  if (useLoadingLocks) loadingLocksManager.start(lockId);

  return forward(operation).map(result => {
    if (useLoadingLocks) loadingLocksManager.stop(lockId);
    return result;
  });
});

const getGraphqlUrl = () => {
  const region = getCurrentRegion();
  const baseUrl =
    REGION_CONFIGS[region]?.baseUrl ||
    REGION_CONFIGS[AWS_REGIONS.EU_WEST_2].baseUrl;
  return `${baseUrl}${GRAPHQL_PATH}`;
};
const uri: () => string = () => getGraphqlUrl();
const authLink = setContext((_, { headers }) => ({
  headers: {
    ...headers,
    ...getSessionHeaders(),
  },
}));
const cache = new InMemoryCache();
const defaultOptions = {
  watchQuery: { errorPolicy: "all" as const },
  query: { errorPolicy: "all" as const },
  mutate: { errorPolicy: "all" as const },
};
const makeApolloClient = (link: ApolloLink) =>
  new ApolloClient({
    connectToDevTools: import.meta.env?.DEV,
    cache,
    defaultOptions,
    link,
  });
export const client = makeApolloClient(
  from([loadingLink, authLink, createHttpLink({ uri })]),
);
export const uploadClient = makeApolloClient(
  from([loadingLink, authLink, createUploadLink({ uri })]),
);
